<script>
export default {
  props: ["ticket"],
  data() {
    return {
      options: [
        { value: null, text: "Select Assignee" },
        { value: "AM1", text: "AM1" },
        { value: "AM2", text: "AM2" },
      ],
      selected: null,
    };
  },
  watch: {},
  methods: {},
};
</script>

<template>
  <div>
    <b-row>
      <b-col cols="4">
        <b-label>Assignee:</b-label>
        <b-form-select
          v-model="selected"
          :options="options"
          class="mb-3"
        ></b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">
        <b-button variant="success">save</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<style></style>
